import React, { useEffect, useState } from "react";

import api from "../../../api";
import Swal from "sweetalert2";
import { ClipboardPaste } from "lucide-react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  FormControl,
  CircularProgress,
  Select,
  MenuItem,
  Chip,
  Box,
  Checkbox,
} from "@mui/material";
import Adminsidebar from "../adminsidebar";
import Adminheader from "../adminheader";
import MatchCard from "./matches_card";
import Button from "../../../UI/button";

export default function FindMatches() {
  const [step, setStep] = useState(1);

  const user = JSON.parse(localStorage.getItem("user"));


  //======================== state for adding a user=========================================

  const [user_profile, setuser_profile] = useState({
   PartnerPrefrences: {
      Gender:"",
      AgeRange: { MinAge: null, MaxAge: null },
      HeightRange: { MinHeight: null, MaxHeight: null },
      MaritialStatus: "",
      HasChildren: false,
      ChildrenCount: 0,
      NonVeg: "",
      Manglik: "",
      Nri: "",
      PermanentResident: false,
      TemporaryResident: false,
      Community: "",
      Religion: "",
      Caste: [],
      Gothram:[],
      MotherTongue: [],
      AnnualFamilyIncome: "",
      PersonalIncome: "",
      PropertySize: [],
      HeighstEducation: [],
      Occupation: [],
      Country: [],
      State: [],
      City: [],
    },
  });



  // get mother tongue

  const[select_loading,setselect_loading]=useState("")

   const [All_Mother_Tongue, setAll_Mother_Tongue] = useState([]);
  const getall_mother_tongue = async () => {
    try {
      setselect_loading("mother_tongue");
      const params = new URLSearchParams();
      params.append("lookup_type", "mother_tongue");
      const resp = await api.get(`api/admin/LookupList?${params.toString()}`);
      setAll_Mother_Tongue(resp.data.data);
    } catch (error) {
      console.log(error);
    } finally {
      setselect_loading("");
    }
  };



  // get religion

   const [All_Religion_Group, setAll_Religion_Group] = useState([]);

  const getall_religion_group = async () => {
    try {
      setselect_loading("religion");
      const params = new URLSearchParams();
      params.append("lookup_type", "religion_group");
      const resp = await api.get(`api/admin/LookupList?${params.toString()}`);
      setAll_Religion_Group(resp.data.data);
    } catch (error) {
      console.log(error);
    } finally {
      setselect_loading("");
    }
  };

  // get cast

   const [All_Cast_Group, setAll_Cast_Group] = useState([]);
  const getall_cast_group = async (selectedId) => {
    try {
      setselect_loading("cast");
      const params = new URLSearchParams();
      params.append("lookup_type", "cast_group");
      params.append("parent_lookup_id", selectedId);
      const resp = await api.get(`api/admin/LookupList?${params.toString()}`);
      setAll_Cast_Group(resp.data.data);
    } catch (error) {
      console.log(error);
    } finally {
      setselect_loading("");
    }
  };

  // get gotra

   const [All_Gothra_Group, setAll_Gothra_Group] = useState([]);
  const getall_gothra_group = async () => {
    try {
      setselect_loading("gotra");
      const params = new URLSearchParams();
      params.append("lookup_type", "gothra_group");
      const resp = await api.get(`api/admin/LookupList?${params.toString()}`);
      setAll_Gothra_Group(resp.data.data);
    } catch (error) {
      console.log(error);
    } finally {
      setselect_loading("");
    }
  };

  // get occupation 

    const [All_Occupation, setAll_Occupation] = useState([]);
  const getall_occupation = async () => {
    try {
      setselect_loading("occupation");
      const params = new URLSearchParams();
      params.append("lookup_type", "occupation");
      const resp = await api.get(`api/admin/LookupList?${params.toString()}`);
      setAll_Occupation(resp.data.data);
    } catch (error) {
      console.log(error);
    } finally {
      setselect_loading("");
    }
  };

  // get education

  const [All_Education_Group, setAll_Education_Group] = useState([]);
  const getAll_Education_Group = async () => {
    try {
      setselect_loading("education");
      const params = new URLSearchParams();
      params.append("lookup_type", "education_group");
      const resp = await api.get(`api/admin/LookupList?${params.toString()}`);
      setAll_Education_Group(resp.data.data)
    } catch (error) {
      console.error(error);
    } finally {
      setselect_loading("");
    }
  };


   // get community

  const [All_Community_Group, setAll_Community_Group] = useState([]);

  const getall_community_group = async () => {
    try {
      setselect_loading("community");
      const params = new URLSearchParams();
      params.append("lookup_type", "community_group");
      const resp = await api.get(`api/admin/LookupList?${params.toString()}`);
      setAll_Community_Group(resp.data.data);
    } catch (error) {
      console.log(error);
    } finally {
      setselect_loading("");
    }
  };


  

  // get income

  const [All_Income_Group, setAll_Income_Group] = useState([]);
 const getall_income_group = async () => {
  try {
    setselect_loading("income");

    const params = new URLSearchParams();
    params.append("lookup_type", "income_group");

    const resp = await api.get(
      `api/admin/LookupList?${params.toString()}`
    );

    const sortedIncome = resp.data.data.sort((a, b) => {
      const getValue = (str = "") => {
        str = str.trim(); // remove extra spaces

        const match = str.match(/(\d+)\s*(Lakh|Crore)/i);
        if (!match) return 0;

        let value = parseInt(match[1]);

        // Convert Crore → Lakh
        if (match[2].toLowerCase() === "crore") {
          value *= 100;
        }

        return value;
      };

      return getValue(a.lookup_value) - getValue(b.lookup_value);
      // 🔼 Small income first
      // For small income last use reverse
      // return getValue(b.lookup_value) - getValue(a.lookup_value);
    });

    setAll_Income_Group(sortedIncome);

  } catch (error) {
    console.log(error);
  } finally {
    setselect_loading("");
  }
};

  // get country

    const [All_Country_Group, setAll_Country_Group] = useState([]);
  const getall_country_group = async () => {
    try {
      setselect_loading("country");
      const params = new URLSearchParams();
      params.append("lookup_type", "country_group");
      const resp = await api.get(`api/admin/LookupList?${params.toString()}`);
      setAll_Country_Group(resp.data.data);
    } catch (error) {
      console.log(error);
    } finally {
      setselect_loading("");
    }
  };

  // get state

   const [All_State_Group, setAll_State_Group] = useState([]);
  const getall_state_group = async (selectedId) => {
    try {
      setselect_loading("state");
      const params = new URLSearchParams();
      params.append("lookup_type", "state_group");
      params.append("parent_lookup_id", selectedId);
      const resp = await api.get(`api/admin/LookupList?${params.toString()}`);
      setAll_State_Group(resp.data.data);
    } catch (error) {
      console.log(error);
    } finally {
      setselect_loading("");
    }
  };

  // get city

    const [All_City_Group, setAll_City_Group] = useState([]);
  const getall_city_group = async (selectedId) => {
    try {
      setselect_loading("city");
      const params = new URLSearchParams();
      params.append("lookup_type", "city_group");
      params.append("parent_lookup_id", selectedId);
      const resp = await api.get(`api/admin/LookupList?${params.toString()}`);
      setAll_City_Group((prev) => [
  ...prev,
  ...resp.data.data,
]);

    } catch (error) {
      console.log(error);
    } finally {
      setselect_loading("");
    }
  };


   // get property size

   const [All_Property_Size, setAll_Property_Size] = useState([]);

  const getall_property_size = async () => {
    try {
      setselect_loading("property_size");
      const params = new URLSearchParams();
      params.append("lookup_type", "property_size");
      const resp = await api.get(`api/admin/LookupList?${params.toString()}`);

      const sortedProperty = resp.data.data.sort((a, b) => {
      const getValue = (str = "") => {
        str = str.trim(); // remove extra spaces

        const match = str.match(/(\d+)\s*(GAJ)/i);
        if (!match) return 0;

        let value = parseInt(match[1]);

        // Convert Crore → Lakh
        if (match[2].toLowerCase() === "crore") {
          value *= 100;
        }

        return value;
      };

      return getValue(a.lookup_value) - getValue(b.lookup_value);
      // 🔼 Small income first
      // For small income last use reverse
      // return getValue(b.lookup_value) - getValue(a.lookup_value);
    });

    setAll_Property_Size(sortedProperty);
    } catch (error) {
      console.log(error);
    } finally {
      setselect_loading("");
    }
  };


  // ===========================common onchange event=======================================

  const handleChange = (section, field, value, isArray = false) => {
    setuser_profile((prev) => {
      const sectionData = prev[section] || {};

      // If the field is meant to store multiple values (array)
      if (isArray) {
        let updatedArray = Array.isArray(sectionData[field])
          ? [...sectionData[field]]
          : [];

        if (updatedArray.includes(value)) {
          // Remove value if already selected (toggle behavior)
          updatedArray = updatedArray.filter((item) => item !== value);
        } else {
          // Add value if not present
          updatedArray.push(value);
        }

        return {
          ...prev,
          [section]: {
            ...sectionData,
            [field]: updatedArray,
          },
        };
      }

      // Otherwise, handle normal single-value field
      return {
        ...prev,
        [section]: {
          ...sectionData,
          [field]: value,
        },
      };
    });
  };


  //============================== multiple value onchange =================================

  const handleMultiSelectChange = (event, fieldName) => {
    const { value } = event.target;
    const newValues = typeof value === "string" ? value.split(",") : value;

    // Update user_profile directly
    setuser_profile((prev) => ({
      ...prev,
      PartnerPrefrences: {
        ...prev.PartnerPrefrences,
        [fieldName]: newValues,
      },
    }));
  };






  //========================= post method for adding new profile===============================

  const[matches,setmatches]=useState([])

const [page, setPage] = useState(1);
const [limit] = useState(10); // fixed or changeable
const [totalPages, setTotalPages] = useState(1);

const[uniqueId,setuniqueId]=useState("")
const find_matches = async (page) => {
  try {
    // Loader
    Swal.fire({
      title: "Finding Matches...",
      text: "Please wait while we search best matches for you.",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const resp = await api.post(
      "api/user/find-matches",
      user_profile,
      {
        params: {
          page: page,
          limit: limit,
          uniqueId: uniqueId,
        },
      }
    );

    setmatches(resp.data.matches);
    setTotalPages(resp.data.totalPages);
    setPage(resp.data.page);

    Swal.close();

    if (resp.status === 200) {
      // =========================
      // PAGE 1 → FULL SUCCESS POPUP
      // =========================
      if (page === 1) {
        Swal.fire({
          icon: "success",
          title: "Matches Found!",
          text: `${resp.data.totalMatches} Matches Found successfully`,
          confirmButtonText: "OK",
        });
      } 
      // =========================
      // PAGE 2+ → SMALL INFO TOAST
      // =========================
      else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "info",
          title: `Page ${page} loaded`,
          text: `${resp.data.matches.length} matches displayed`,
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      }
    }
  } catch (error) {
    console.log(error);

    Swal.fire({
      icon: "error",
      title: "Error!",
      text:
        error.response?.data?.error ||
        "Something went wrong! Please try again.",
    });
  }
};



  
  return (
    <div>
      <Adminheader />

      <div className="layout">
        <Adminsidebar />
        <div className="content-wrapper">
          <div className="main-content">
      <div className="min-h-screen bg-gradient-to-br from-pink-50 via-white to-red-50 flex items-center justify-center px-4 py-10">
        <div className="w-full max-w-3xl bg-white rounded-2xl shadow-xl overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-red-600 to-pink-600 text-white py-6 px-6 text-center">
          <h1 className="text-3xl font-bold">
              Find Matches
            </h1>

            <p className="text-sm opacity-90 mt-1">
              Complete your details to get the best matches!
            </p>
          </div>

          {/* Form Body */}
          <div className="p-6 sm:p-8 space-y-6">
            {/*================================ STEP 6 - Partner Preferences========================= */}
         
             <div className="space-y-5">
                <h2 className="text-xl font-semibold text-gray-800 mb-2">
                  Partner Preferences
                </h2>
                <div className="space-y-5">
                  <h2 className="text-xl font-semibold text-gray-800 mb-2">
                    Preferred Partner Details
                  </h2>

                    <div>
                      <label className="block text-gray-700 font-medium mb-1">
                        Gender(your gender)
                      </label>
                      <select
                        className="border rounded-lg p-3 focus:ring-2 focus:ring-red-500 w-full"
                        name="Gender"
                        onChange={(e) =>
                          handleChange(
                            "PartnerPrefrences",
                            "Gender",
                            e.target.value
                          )
                        }
                        onClick={() => {getall_mother_tongue()}}
                      >
                        <option
                          value={
                            user_profile?.PartnerPrefrences?.Gender || ""
                          }
                        >
                          {user_profile?.PartnerPrefrences?.Gender ||
                            "Select Gender"}
                        </option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                      
                      </select>
                    </div>

                <div>
                    <label className="block text-gray-700 font-medium mb-1">
                      Enter a Unique Id
                    </label>
                    <input
                      type="text"
                      name="Name"
                      className="border rounded-lg p-3 focus:ring-2 focus:ring-red-500 w-full"
                      placeholder="123456"
                      onChange={(e) =>
                        setuniqueId(e.target.value)
                      }
                    />
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {/* Preferred Age Range */}
                    <div>
                      <label className="block text-gray-700 font-medium mb-1">
                        Preferred Age Range
                      </label>
                      <div className="flex gap-2">
                        <select
                          className="border rounded-lg p-3 focus:ring-2 focus:ring-red-500 w-full"
                          name="MinAge"
                          onChange={(e) =>
                            setuser_profile({
                              ...user_profile,
                              PartnerPrefrences: {
                                ...user_profile.PartnerPrefrences,
                                AgeRange: {
                                  ...user_profile.PartnerPrefrences.AgeRange,
                                  MinAge: e.target.value,
                                },
                              },
                            })
                          }
                        >
                          <option
                            value={
                              user_profile?.PartnerPrefrences?.AgeRange
                                ?.MinAge || ""
                            }
                          >
                            {user_profile?.PartnerPrefrences?.AgeRange.MinAge ||
                              "Min Age"}
                          </option>
                          {Array.from({ length: 30 }, (_, i) => (
                            <option key={i} value={i + 18}>
                              {i + 18}
                            </option>
                          ))}
                        </select>
                        <select
                          className="border rounded-lg p-3 focus:ring-2 focus:ring-red-500 w-full"
                          name="MaxAge"
                          onChange={(e) =>
                            setuser_profile({
                              ...user_profile,
                              PartnerPrefrences: {
                                ...user_profile.PartnerPrefrences,
                                AgeRange: {
                                  ...user_profile.PartnerPrefrences.AgeRange,
                                  MaxAge: e.target.value,
                                },
                              },
                            })
                          }
                        >
                          <option
                            value={
                              user_profile?.PartnerPrefrences?.AgeRange
                                ?.MaxAge || ""
                            }
                          >
                            {user_profile?.PartnerPrefrences?.AgeRange.MaxAge ||
                              "Max Age"}
                          </option>
                          {Array.from({ length: 30 }, (_, i) => (
                            <option key={i} value={i + 18}>
                              {i + 18}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Preferred Height Range */}
                    <div>
                      <label className="block text-gray-700 font-medium mb-1">
                        Preferred Height Range
                      </label>
                      <div className="flex gap-2">
                        <select
                          className="border rounded-lg p-3 focus:ring-2 focus:ring-red-500 w-full"
                          name="MinHeight"
                          onChange={(e) =>
                            setuser_profile({
                              ...user_profile,
                              PartnerPrefrences: {
                                ...user_profile.PartnerPrefrences,
                                HeightRange: {
                                  ...user_profile.PartnerPrefrences.HeightRange,
                                  MinHeight: e.target.value,
                                },
                              },
                            })
                          }
                        >
                          <option
                            value={
                              user_profile?.PartnerPrefrences?.HeightRange
                                ?.MinHeight || ""
                            }
                          >
                            {user_profile?.PartnerPrefrences?.HeightRange
                              .MinHeight || "Min Height"}
                          </option>
                          {[
                            "4'8\"",
                            "4'9\"",
                            "4'10\"",
                            "4'11\"",
                            "5'0\"",
                            "5'1\"",
                            "5'2\"",
                            "5'3\"",
                            "5'4\"",
                            "5'5\"",
                            "5'6\"",
                            "5'7\"",
                            "5'8\"",
                            "5'9\"",
                            "5'10\"",
                            "5'11\"",
                            "6'0\"",
                            "6'1\"",
                            "6'2\"",
                            "6'3\"",
                            "6'4\"",
                            "6'5\"",
                          ].map((h) => (
                            <option key={h} value={h}>
                              {h}
                            </option>
                          ))}
                        </select>
                        <select
                          className="border rounded-lg p-3 focus:ring-2 focus:ring-red-500 w-full"
                          name="MaxHeight"
                          onChange={(e) =>
                            setuser_profile({
                              ...user_profile,
                              PartnerPrefrences: {
                                ...user_profile.PartnerPrefrences,
                                HeightRange: {
                                  ...user_profile.PartnerPrefrences.HeightRange,
                                  MaxHeight: e.target.value,
                                },
                              },
                            })
                          }
                        >
                          <option
                            value={
                              user_profile?.PartnerPrefrences?.HeightRange
                                ?.MaxHeight || ""
                            }
                          >
                            {user_profile?.PartnerPrefrences?.HeightRange
                              .MaxHeight || "Max Height"}
                          </option>
                          {[
                            "4'8\"",
                            "4'9\"",
                            "4'10\"",
                            "4'11\"",
                            "5'0\"",
                            "5'1\"",
                            "5'2\"",
                            "5'3\"",
                            "5'4\"",
                            "5'5\"",
                            "5'6\"",
                            "5'7\"",
                            "5'8\"",
                            "5'9\"",
                            "5'10\"",
                            "5'11\"",
                            "6'0\"",
                            "6'1\"",
                            "6'2\"",
                            "6'3\"",
                            "6'4\"",
                            "6'5\"",
                          ].map((h) => (
                            <option key={h} value={h}>
                              {h}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Marital Status */}
                    <div>
                      <label className="block text-gray-700 font-medium mb-1">
                        Marital Status
                      </label>
                      <div className="flex gap-3">
                        <label>
                          <input
                            type="radio"
                            name="MaritialStatus"
                            value="Single"
                            checked={
                              user_profile.PartnerPrefrences.MaritialStatus ===
                              "Single"
                            }
                            onChange={(e) =>
                              handleChange(
                                "PartnerPrefrences",
                                "MaritialStatus",
                                e.target.value,
                              )
                            }
                          />
                          Single
                        </label>
                        <label>
                          <input
                            type="radio"
                            name="MaritialStatus"
                            value="Divorced"
                            checked={
                              user_profile.PartnerPrefrences.MaritialStatus ===
                              "Divorced"
                            }
                            onChange={(e) =>
                              handleChange(
                                "PartnerPrefrences",
                                "MaritialStatus",
                                e.target.value,
                              )
                            }
                          />{" "}
                          Divorced
                        </label>
                        <label>
                          <input
                            type="radio"
                            name="MaritialStatus"
                            value="Widow/Widower"
                            checked={
                              user_profile.PartnerPrefrences.MaritialStatus ===
                              "Widow/Widower"
                            }
                            onChange={(e) =>
                              handleChange(
                                "PartnerPrefrences",
                                "MaritialStatus",
                                e.target.value,
                              )
                            }
                          />
                          Widow/Widower
                        </label>
                      </div>
                    </div>

                    {/* ✅ Show extra fields if Divorce is selected */}
                    {(user_profile.PartnerPrefrences.MaritialStatus ===
                      "Divorced" ||
                      user_profile.PartnerPrefrences.MaritialStatus ===
                        "Widow/Widower") && (
                      <div className="mt-3 ml-4 space-y-2">
                        <label className="flex items-center gap-2">
                          <input
                            type="checkbox"
                            className="accent-red-600"
                            checked={
                              user_profile.PartnerPrefrences.HasChildren ||
                              false
                            }
                            onChange={(e) =>
                              handleChange(
                                "PartnerPrefrences",
                                "HasChildren",
                                e.target.checked,
                              )
                            }
                          />
                          Do you have children?
                        </label>

                        {/* ✅ If user has children, show number input */}
                        {user_profile.PartnerPrefrences.HasChildren && (
                          <div className="flex items-center gap-2 ml-6">
                            <label className="text-sm text-gray-700">
                              How many children?
                            </label>
                            <input
                              type="number"
                              min="1"
                              className="border rounded-md p-2 w-24 focus:ring-2 focus:ring-red-500 focus:outline-none"
                              value={
                                user_profile.PartnerPrefrences.ChildrenCount ||
                                0
                              }
                              onChange={(e) =>
                                handleChange(
                                  "PartnerPrefrences",
                                  "ChildrenCount",
                                  e.target.value,
                                )
                              }
                            />
                          </div>
                        )}
                      </div>
                    )}

                    {/* Food Preference */}
                    <div>
                      <label className="block text-gray-700 font-medium mb-1">
                        Non-Veg
                      </label>
                      <div className="flex gap-3">
                        <label>
                          <input
                            type="radio"
                            name="non-veg"
                            value="Yes"
                            checked={
                              user_profile.PartnerPrefrences.NonVeg === "Yes"
                            }
                            onChange={(e) =>
                              handleChange(
                                "PartnerPrefrences",
                                "NonVeg",
                                e.target.value,
                              )
                            }
                          />
                          Yes
                        </label>
                        <label>
                          <input
                            type="radio"
                            name="non-veg"
                            value="No"
                            checked={
                              user_profile.PartnerPrefrences.NonVeg === "No"
                            }
                            onChange={(e) =>
                              handleChange(
                                "PartnerPrefrences",
                                "NonVeg",
                                e.target.value,
                              )
                            }
                          />
                          No
                        </label>
                      </div>
                    </div>

                    {/* Manglik */}
                    <div>
                      <label className="block text-gray-700 font-medium mb-1">
                        Manglik
                      </label>
                      <div className="flex gap-3">
                        <label>
                          <input
                            type="radio"
                            name="manglik"
                            value="Yes"
                            checked={
                              user_profile.PartnerPrefrences.Manglik === "Yes"
                            }
                            onChange={(e) =>
                              handleChange(
                                "PartnerPrefrences",
                                "Manglik",
                                e.target.value,
                              )
                            }
                          />{" "}
                          Yes
                        </label>
                        <label>
                          <input
                            type="radio"
                            name="manglik"
                            value="No"
                            checked={
                              user_profile.PartnerPrefrences.Manglik === "No"
                            }
                            onChange={(e) =>
                              handleChange(
                                "PartnerPrefrences",
                                "Manglik",
                                e.target.value,
                              )
                            }
                          />
                          No
                        </label>
                      </div>
                    </div>

                    {/* NRI */}
                    <div>
                      <label className="block text-gray-700 font-medium mb-1">
                        NRI
                      </label>
                      <div className="flex gap-3">
                        <label>
                          <input
                            type="radio"
                            name="nri"
                            value="Yes"
                            checked={
                              user_profile.PartnerPrefrences.Nri === "Yes"
                            }
                            onChange={(e) =>
                              handleChange(
                                "PartnerPrefrences",
                                "Nri",
                                e.target.value,
                              )
                            }
                          />{" "}
                          Yes
                        </label>
                        <label>
                          <input
                            type="radio"
                            name="nri"
                            value="No"
                            checked={
                              user_profile.PartnerPrefrences.Nri === "No"
                            }
                            onChange={(e) =>
                              handleChange(
                                "PartnerPrefrences",
                                "Nri",
                                e.target.value,
                              )
                            }
                          />{" "}
                          No
                        </label>
                      </div>
                    </div>

                    {/* ✅ If user nri */}
                    {user_profile?.PartnerPrefrences?.Nri === "Yes" && (
                      <div className="flex flex-col gap-2 ml-6">
                        <label className="text-sm text-gray-700 font-medium">
                          Resident Status
                        </label>

                        <label className="flex items-center gap-2 text-sm text-gray-600">
                          <input
                            type="checkbox"
                            name="PermanentResident"
                            className="w-4 h-4"
                            checked={
                              user_profile.PartnerPrefrences.PermanentResident
                            }
                            onChange={(e) =>
                              setuser_profile((prev) => ({
                                ...prev,
                                PartnerPrefrences: {
                                  ...prev.PartnerPrefrences,
                                  PermanentResident: e.target.checked,
                                  TemporaryResident: false,
                                },
                              }))
                            }
                          />
                          Permanent Resident
                        </label>

                        <label className="flex items-center gap-2 text-sm text-gray-600">
                          <input
                            type="checkbox"
                            name="TemporaryResident"
                            className="w-4 h-4"
                            checked={
                              user_profile.PartnerPrefrences.TemporaryResident
                            }
                            onChange={(e) =>
                              setuser_profile((prev) => ({
                                ...prev,
                                PartnerPrefrences: {
                                  ...prev.PartnerPrefrences,
                                  TemporaryResident: e.target.checked,
                                  PermanentResident: false,
                                },
                              }))
                            }
                          />
                          Temporary Resident
                        </label>
                      </div>
                    )}

                    {/* Religion */}
                    <div>
                      <label className="block text-gray-700 font-medium mb-1">
                        Religion
                      </label>
                      <select
                        className="border rounded-lg p-3 focus:ring-2 focus:ring-red-500 w-full"
                        name="Religion"
                        onChange={(e) =>{
                          const selectedId =
                          e.target.selectedOptions[0].getAttribute("data-id");
                        
                          handleChange(
                            "PartnerPrefrences",
                            "Religion",
                            e.target.value,
                          )
                          getall_cast_group(selectedId);
                        }
                      }
                        onClick={() => {
                          getall_religion_group();
                        }}
                      >
                        <option
                          value={
                            user_profile?.PartnerPrefrences?.Religion || ""
                          }
                        >
                          {user_profile?.PartnerPrefrences?.Religion ||
                            "Select Religion"}
                        </option>
                        {All_Religion_Group.map((item) => (
                          <option key={item._id} value={item.lookup_value} data-id={item._id}>
                            {item.lookup_value}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Community */}
                    <div>
                      <label className="block text-gray-700 font-medium mb-1">
                        Community
                      </label>
                      <select
                        className="border rounded-lg p-3 focus:ring-2 focus:ring-red-500 w-full"
                        name="Community"
                        onChange={(e) =>
                          handleChange(
                            "PartnerPrefrences",
                            "Community",
                            e.target.value,
                          )
                        }
                        onClick={() => {
                          getall_community_group();
                        }}
                      >
                        <option
                          value={
                            user_profile?.PartnerPrefrences?.Community || ""
                          }
                        >
                          {user_profile?.PartnerPrefrences?.Community ||
                            "Select Community"}
                        </option>
                        {All_Community_Group.map((item) => (
                          <option key={item._id} value={item.lookup_value}>
                            {item.lookup_value}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Caste */}

                    <div>
                      <label className="block text-gray-700 font-medium mb-1">
                        Caste
                      </label>

                      <FormControl fullWidth>
                        <Select
                          name="Caste"
                          multiple
                          value={user_profile?.PartnerPrefrences?.Caste || []}
                          onOpen={() => {
                            getall_cast_group();
                          }}
                          onChange={(e) => {
                            handleMultiSelectChange(e, "Caste");
                          }}
                          displayEmpty
                          renderValue={(selected) => {
                            if (selected.length === 0) {
                              return (
                                <span style={{ color: "#888" }}>
                                  Select Caste
                                </span>
                              );
                            }
                            return (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 0.5,
                                }}
                              >
                                {selected.map((value) => (
                                  <Chip
                                    key={value}
                                    label={value}
                                    size="small"
                                    color="primary"
                                    variant="outlined"
                                  />
                                ))}
                              </Box>
                            );
                          }}
                        >
                          {All_Cast_Group.map((option) => (
                            <MenuItem
                              key={option._id}
                              value={option.lookup_value}
                            >
                              <Checkbox
                                checked={user_profile?.PartnerPrefrences?.Caste.includes(
                                  option.lookup_value,
                                )}
                                color="primary"
                              />
                              {option.lookup_value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>

                           {/* Gothram */}

                    <div>
                      <label className="block text-gray-700 font-medium mb-1">
                        Gothram
                      </label>

                      <FormControl fullWidth>
                        <Select
                          name="Caste"
                          multiple
                          value={user_profile?.PartnerPrefrences?.Gothram || []}
                          onOpen={() => {
                            getall_gothra_group();
                          }}
                          onChange={(e) => {
                            handleMultiSelectChange(e, "Gothram");
                          }}
                          displayEmpty
                          renderValue={(selected) => {
                            if (selected.length === 0) {
                              return (
                                <span style={{ color: "#888" }}>
                                  Select Gothram
                                </span>
                              );
                            }
                            return (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 0.5,
                                }}
                              >
                                {selected.map((value) => (
                                  <Chip
                                    key={value}
                                    label={value}
                                    size="small"
                                    color="primary"
                                    variant="outlined"
                                  />
                                ))}
                              </Box>
                            );
                          }}
                        >
                          {All_Gothra_Group.map((option) => (
                            <MenuItem
                              key={option._id}
                              value={option.lookup_value}
                            >
                              <Checkbox
                                checked={user_profile?.PartnerPrefrences?.Gothram.includes(
                                  option.lookup_value,
                                )}
                                color="primary"
                              />
                              {option.lookup_value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>

                    {/* Mother Tongue */}

                    <div>
                      <label className="block text-gray-700 font-medium mb-1">
                        Mother Tongue
                      </label>

                      <FormControl fullWidth>
                        <Select
                          name="MotherTongue"
                          multiple
                          value={
                            user_profile?.PartnerPrefrences?.MotherTongue || []
                          }
                          onOpen={() => {
                            getall_mother_tongue();
                          }}
                          onChange={(e) => {
                            handleMultiSelectChange(e, "MotherTongue");
                          }}
                          displayEmpty
                          renderValue={(selected) => {
                            if (selected.length === 0) {
                              return (
                                <span style={{ color: "#888" }}>
                                  Select Caste
                                </span>
                              );
                            }
                            return (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 0.5,
                                }}
                              >
                                {selected.map((value) => (
                                  <Chip
                                    key={value}
                                    label={value}
                                    size="small"
                                    color="primary"
                                    variant="outlined"
                                  />
                                ))}
                              </Box>
                            );
                          }}
                        >
                          {All_Mother_Tongue.map((option) => (
                            <MenuItem
                              key={option._id}
                              value={option.lookup_value}
                            >
                              <Checkbox
                                checked={user_profile?.PartnerPrefrences?.MotherTongue.includes(
                                  option.lookup_value,
                                )}
                                color="primary"
                              />
                              {option.lookup_value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>

                    {/* Annual Family Income */}
                    <div>
                      <label className="block text-gray-700 font-medium mb-1">
                        Annual Family Income
                      </label>
                      <select
                        className="border rounded-lg p-3 focus:ring-2 focus:ring-red-500 w-full"
                        name="AnnualFamilyIncome"
                        onChange={(e) =>
                          handleChange(
                            "PartnerPrefrences",
                            "AnnualFamilyIncome",
                            e.target.value,
                          )
                        }
                        onClick={() => {
                          getall_income_group();
                        }}
                      >
                        <option
                          value={
                            user_profile?.PartnerPrefrences
                              ?.AnnualFamilyIncome || ""
                          }
                        >
                          {user_profile?.PartnerPrefrences
                            ?.AnnualFamilyIncome ||
                            "Select Annual Family Income"}
                        </option>
                        {All_Income_Group.map((item) => (
                          <option key={item._id} value={item.lookup_value}>
                            {item.lookup_value}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Personal Income */}
                    <div>
                      <label className="block text-gray-700 font-medium mb-1">
                        Personal Income
                      </label>
                      <select
                        className="border rounded-lg p-3 focus:ring-2 focus:ring-red-500 w-full"
                        name="PersonalIncome"
                        onChange={(e) =>
                          handleChange(
                            "PartnerPrefrences",
                            "PersonalIncome",
                            e.target.value,
                          )
                        }
                        onClick={() => {
                          getall_income_group();
                        }}
                      >
                        <option
                          value={
                            user_profile?.PartnerPrefrences?.PersonalIncome ||
                            ""
                          }
                        >
                          {user_profile?.PartnerPrefrences?.PersonalIncome ||
                            "Select Personal Income"}
                        </option>
                        {All_Income_Group.map((item) => (
                          <option key={item._id} value={item.lookup_value}>
                            {item.lookup_value}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Property Size */}
                    <div>
                      <label className="block text-gray-700 font-medium mb-1">
                        Property Size
                      </label>

                      <FormControl fullWidth>
                        <Select
                          name="PropertySize"
                          multiple
                          value={
                            user_profile?.PartnerPrefrences?.PropertySize || []
                          }
                          onOpen={() => {
                            getall_property_size();
                          }}
                          onChange={(e) => {
                            handleMultiSelectChange(e, "PropertySize");
                          }}
                          displayEmpty
                          renderValue={(selected) => {
                            if (selected.length === 0) {
                              return (
                                <span style={{ color: "#888" }}>
                                  Select Property Size
                                </span>
                              );
                            }
                            return (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 0.5,
                                }}
                              >
                                {selected.map((value) => (
                                  <Chip
                                    key={value}
                                    label={value}
                                    size="small"
                                    color="primary"
                                    variant="outlined"
                                  />
                                ))}
                              </Box>
                            );
                          }}
                        >
                          {All_Property_Size.map((option) => (
                            <MenuItem
                              key={option._id}
                              value={option.lookup_value}
                            >
                              <Checkbox
                                checked={user_profile?.PartnerPrefrences?.PropertySize.includes(
                                  option.lookup_value,
                                )}
                                color="primary"
                              />
                              {option.lookup_value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>

                    {/* Education */}
                    <div>
                      <label className="block text-gray-700 font-medium mb-1">
                        Highest Education
                      </label>

                      <FormControl fullWidth>
                        <Select
                          name="HeighstEducation"
                          multiple
                          value={
                            user_profile?.PartnerPrefrences?.HeighstEducation ||
                            []
                          }
                          onOpen={() => {
                            getAll_Education_Group();
                          }}
                          onChange={(e) => {
                            handleMultiSelectChange(e, "HeighstEducation");
                          }}
                          displayEmpty
                          renderValue={(selected) => {
                            if (selected.length === 0) {
                              return (
                                <span style={{ color: "#888" }}>
                                  Select Education
                                </span>
                              );
                            }
                            return (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 0.5,
                                }}
                              >
                                {selected.map((value) => (
                                  <Chip
                                    key={value}
                                    label={value}
                                    size="small"
                                    color="primary"
                                    variant="outlined"
                                  />
                                ))}
                              </Box>
                            );
                          }}
                        >
                          {All_Education_Group.map((option) => (
                            <MenuItem
                              key={option._id}
                              value={option.lookup_value}
                            >
                              <Checkbox
                                checked={user_profile?.PartnerPrefrences?.HeighstEducation.includes(
                                  option.lookup_value,
                                )}
                                color="primary"
                              />
                              {option.lookup_value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>

                    {/* Occupation */}
                    <div>
                      <label className="block text-gray-700 font-medium mb-1">
                        Occupation
                      </label>
                      <FormControl fullWidth>
                        <Select
                          name="Occupation"
                          multiple
                          value={
                            user_profile?.PartnerPrefrences?.Occupation || []
                          }
                          onOpen={() => {
                            getall_occupation();
                          }}
                          onChange={(e) => {
                            handleMultiSelectChange(e, "Occupation");
                          }}
                          displayEmpty
                          renderValue={(selected) => {
                            if (selected.length === 0) {
                              return (
                                <span style={{ color: "#888" }}>
                                  Select Occupation
                                </span>
                              );
                            }
                            return (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 0.5,
                                }}
                              >
                                {selected.map((value) => (
                                  <Chip
                                    key={value}
                                    label={value}
                                    size="small"
                                    color="primary"
                                    variant="outlined"
                                  />
                                ))}
                              </Box>
                            );
                          }}
                        >
                          {All_Occupation.map((option) => (
                            <MenuItem
                              key={option._id}
                              value={option.lookup_value}
                            >
                              <Checkbox
                                checked={user_profile?.PartnerPrefrences?.Occupation.includes(
                                  option.lookup_value,
                                )}
                                color="primary"
                              />
                              {option.lookup_value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>

                    {/* Country */}
                    <div>
                      <label className="block text-gray-700 font-medium mb-1">
                        Country
                      </label>
                      <FormControl fullWidth>
                        <Select
                          name="Country"
                          multiple
                          value={user_profile?.PartnerPrefrences?.Country || []}
                          onOpen={() => {
                            getall_country_group();
                          }}
                          onChange={(e) => {
                            handleMultiSelectChange(e, "Country");
                          }}
                          displayEmpty
                          renderValue={(selected) => {
                            if (selected.length === 0) {
                              return (
                                <span style={{ color: "#888" }}>
                                  Select Country
                                </span>
                              );
                            }
                            return (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 0.5,
                                }}
                              >
                                {selected.map((value) => (
                                  <Chip
                                    key={value}
                                    label={value}
                                    size="small"
                                    color="primary"
                                    variant="outlined"
                                  />
                                ))}
                              </Box>
                            );
                          }}
                        >
                            {select_loading === "country" && (
    <MenuItem disabled>
      <CircularProgress size={20} sx={{ mr: 1 }} />
      Loading...
    </MenuItem>
  )}
                          {All_Country_Group.map((option) => (
                            <MenuItem
                              key={option._id}
                              value={option.lookup_value}
                              data-id={option._id}
                              onClick={() => getall_state_group(option._id)}
                            >
                              <Checkbox
                                checked={user_profile?.PartnerPrefrences?.Country.includes(
                                  option.lookup_value,
                                )}
                                color="primary"
                              />
                              {option.lookup_value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>

                    {/* State */}
                    <div>
                      <label className="block text-gray-700 font-medium mb-1">
                        State
                      </label>
                      <FormControl fullWidth>
                        <Select
                          name="State"
                          multiple
                          value={user_profile?.PartnerPrefrences?.State || []}
                          onOpen={() => {
                            getall_state_group();
                          }}
                          onChange={(e) => {
                            handleMultiSelectChange(e, "State");
                          }}
                          displayEmpty
                          renderValue={(selected) => {
                            if (selected.length === 0) {
                              return (
                                <span style={{ color: "#888" }}>
                                  Select State
                                </span>
                              );
                            }
                            return (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 0.5,
                                }}
                              >
                                {selected.map((value) => (
                                  <Chip
                                    key={value}
                                    label={value}
                                    size="small"
                                    color="primary"
                                    variant="outlined"
                                  />
                                ))}
                              </Box>
                            );
                          }}
                        >
                                                    {select_loading === "state" && (
    <MenuItem disabled>
      <CircularProgress size={20} sx={{ mr: 1 }} />
      Loading...
    </MenuItem>
  )}
                          {All_State_Group.map((option) => (
                            <MenuItem
                              key={option._id}
                              value={option.lookup_value}
                              data-id={option._id}
                              onClick={() => getall_city_group(option._id)}
                            >
                              <Checkbox
                                checked={user_profile?.PartnerPrefrences?.State.includes(
                                  option.lookup_value,
                                )}
                                color="primary"
                              />
                              {option.lookup_value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>

                    {/* City */}
                    <div>
                      <label className="block text-gray-700 font-medium mb-1">
                        City
                      </label>
                      <FormControl fullWidth>
                        <Select
                          name="City"
                          multiple
                          value={user_profile?.PartnerPrefrences?.City || []}
                          onOpen={() => {
                            getall_city_group();
                          }}
                          onChange={(e) => {
                            handleMultiSelectChange(e, "City");
                          }}
                          displayEmpty
                          renderValue={(selected) => {
                            if (selected.length === 0) {
                              return (
                                <span style={{ color: "#888" }}>
                                  Select City
                                </span>
                              );
                            }
                            return (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 0.5,
                                  maxHeight: "40px",
                                  overflowY: "auto", 
                                }}
                              >
                                {selected.map((value) => (
                                  <Chip
                                    key={value}
                                    label={value}
                                    size="small"
                                    color="primary"
                                    variant="outlined"
                                    
                                  />
                                ))}
                              </Box>
                            );
                          }}
                        >
                          {select_loading === "city" && (
    <MenuItem disabled>
      <CircularProgress size={20} sx={{ mr: 1 }} />
      Loading...
    </MenuItem>
  )}
                          {All_City_Group.map((option) => (
                            <MenuItem
                              key={option._id}
                              value={option.lookup_value}
                            >
                              <Checkbox
                                checked={user_profile?.PartnerPrefrences?.City.includes(
                                  option.lookup_value,
                                )}
                                color="primary"
                              />
                              {option.lookup_value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </div>
              </div>
        

          </div>

          {/* Navigation Buttons */}
          <div className="flex justify-between items-center px-6 py-4 bg-gray-50 border-t">
              <button
                className="px-6 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700"
                // onClick={add_new_profile}
              >
                Cancel
              </button>

        
              <button
                className="px-6 py-2 rounded-lg bg-green-600 text-white hover:bg-green-700"
                onClick={find_matches}
              >
                Find
              </button>
         
          </div>
        </div>
      </div>

      {/* show matches start */}
<div className="w-full max-w-full px-2 sm:px-4 md:px-8 lg:px-16">
  <MatchCard matches={matches} />
</div>

                {totalPages > 1 && (
  <div className="flex items-center justify-between mt-4 border-t pt-3">
    <Button
      variant="outline"
      size="sm"
      disabled={page === 1}
      onClick={() => find_matches(page - 1)}
    >
      Prev
    </Button>

    <span className="text-sm text-gray-600">
      Page <b>{page}</b> of <b>{totalPages}</b>
    </span>

    <Button
      variant="outline"
      size="sm"
      disabled={page === totalPages}
      onClick={() => find_matches(page + 1)}
    >
      Next
    </Button>
  </div>
)}



 {/* show matches end */}


      </div>
    </div>
    </div>
    </div>
  );
}
